import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ListEmployees from '../../list-employees';
import AppHeader from '../../header';
import AppLayoutComponent from '../common';
export default function HomePageContent() {
    return (_jsx(AppLayoutComponent, { content: _jsxs(_Fragment, { children: [_jsx(AppHeader, { title: "Home" }, void 0),
                _jsx(ListEmployees, {}, void 0)] }, void 0) }, void 0));
}
